export function loader() {
  const spinner = document.getElementById('loading');
  spinner.classList.add('loaded');

  setTimeout(() => {
    spinner.remove();
  }, 5000);

  document.addEventListener('DOMContentLoaded', () => {
    spinner.remove();
  });
}
